import { render } from "./NewsEdit.vue?vue&type=template&id=3c344133"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__